<template>
        <div class="grid">
            <div class="col-12">
                    <div class="vector-container">
                    <preload-form>
                        <div class="krm-grid" style="margin-top:50px;">
                            <div class="col-12">
                                <div style="float:left">
                                    <h1>Конфігуратор установок КРП</h1>
                                </div>
                                <div style="float:right" class="description_btn_container">
                                    <a href="javascript:void(0)" v-on:click="displayKrpModal = true" class="info_btn">
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                                        </svg>
                                        Опис роботи сервісу
                                    </a>
                                </div>
                                <div style="clear:both"></div>
                            </div>
                            <div class="krm-first-column krm-column">
                                <div class="field col-12 p-fluid">
                                    <p>Початкові дані</p>
                                    <div class="source-data">
                                        <label for="power">Потужність КУ, кВАр</label>
                                        <InputNumber
                                            :min="10"
                                            :max="1000"
                                            id="power"
                                            v-model="model['power']['value']"
                                            :disabled="model['power']['readonly']"
                                            label="Укажите мощность КУ"
                                            mode="decimal"
                                            :useGrouping="false"
                                        />
                                        <label for="stepsNumber">Кількість ступенів</label>
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            id="stepsNumber"
                                            v-model="model['stepsNumber']['value']"
                                            :options="stepsNumber"
                                            optionLabel="value"
                                            optionValue="id"
                                            placeholder="Вибрати значення"
                                            :loading="model['stepsNumber']['load']"
                                        />
                                        <label for="minStep">Мінімальна ступінь</label>
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            id="minStep"
                                            v-model="model['minStep']['value']"
                                            :disabled="model['minStep']['readonly']"
                                            :options="minSteps"
                                            optionLabel="value"
                                            optionValue="id"
                                            placeholder="Вибрати значення"
                                            :loading="model['minStep']['load']"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div class="field col-12 p-fluid">
                                        <p>Q, Ввідний вимикач</p>
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            v-model="model['inputSwitch']['value']"
                                            :options="inputSwitches"
                                            :show-clear="true"
                                            optionLabel="value"
                                            optionValue="id"
                                            placeholder="Вибрати значення"
                                            :loading="model['inputSwitch']['load']"
                                        />
                                    </div>
                                    <div class="field col-12 p-fluid">
                                        <p>Ошинівка та додат. матеріали</p>
                                        <div class="grid busbar">
                                            <div class="field-radiobutton col-6">
                                                <RadioButton id="busbar_yes" name="busbar" :value="true" v-model="model['busbar']['value']" />
                                                <label for="busbar_yes">Так</label>
                                            </div>
                                            <div class="field-radiobutton col-6">
                                                <RadioButton id="busbar_no" name="busbar" :value="false" v-model="model['busbar']['value']" />
                                                <label for="busbar_no">Ні</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field col-12 p-fluid">
                                        <p>QS, Захист банок</p>
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            :loading="model['protection']['load']"
                                            v-model="model['protection']['value']"
                                            :options="protections"
                                            :show-clear="true"
                                            optionLabel="value"
                                            optionValue="id"
                                            placeholder="Вибрати значення" />
                                    </div>
                                    <div class="field col-12 p-fluid">
                                        <p>KM, Контактори</p>
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            :loading="model['contactor']['load']"
                                            v-model="model['contactor']['value']"
                                            :options="contactors"
                                            :show-clear="true"
                                            optionLabel="value"
                                            optionValue="id"
                                            placeholder="Вибрати значення" />
                                    </div>
                                    <div class="field col-12 p-fluid">
                                        <p>C, Конденсатори</p>
                                        <div class="capacitors-data">
                                            <label>Напруга конд., В</label>
                                            <Dropdown
                                                :empty-message="emptyMessage"
                                                :loading="model['voltageCapacitor']['load']"
                                                v-model="model['voltageCapacitor']['value']"
                                                :options="voltageCapacitors"
                                                :show-clear="true"
                                                optionLabel="value"
                                                optionValue="id"
                                                placeholder="Вибрати значення" />
                                            <label>Фільтрування</label>
                                            <div class="grid">
                                                <div class="field-radiobutton col-6">
                                                    <RadioButton name="filter" value="no" v-model="model['filter']['value']" />
                                                    <label>Ні</label>
                                                </div>
                                                <div class="field-radiobutton col-6">
                                                    <RadioButton name="filter" value="7" v-model="model['filter']['value']" />
                                                    <label>7%</label>
                                                </div>
                                                <div class="field-radiobutton col-6">
                                                    <RadioButton name="filter" value="5,67" v-model="model['filter']['value']" />
                                                    <label>5.67%</label>
                                                </div>
                                                <div class="field-radiobutton col-6">
                                                    <RadioButton name="filter" value="14" v-model="model['filter']['value']" />
                                                    <label>14%</label>
                                                </div>
                                            </div>
                                            <label>Виробник</label>
                                            <Dropdown
                                                :empty-message="emptyMessage"
                                                :loading="model['capacitor']['load']"
                                                v-model="model['capacitor']['value']"
                                                :options="capacitors"
                                                :show-clear="true"
                                                optionLabel="value"
                                                optionValue="id"
                                                placeholder="Вибрати значення" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="krm-second-column krm-column">
                                <svg width="100%" height="880" viewBox="0 0 264 880" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_4233_48659)">
                                        <line class="banka" x1="105.745" y1="593.697" x2="105.745" y2="652.733"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line x1="105.734" y1="861.764" x2="105.734" y2="697.764" stroke="black"/>
                                        <line x1="224.418" y1="862" x2="224.418" y2="698" stroke="black"/>
                                        <line x1="106.294" y1="304.44" x2="106.294" y2="492.264" stroke="black"/>
                                        <line x1="162.851" y1="492.263" x2="162.851" y2="304.44" stroke="black"/>
                                        <line x1="224.704" y1="304.44" x2="224.704" y2="492.264" stroke="black"/>
                                        <line class="banka" y1="-0.5" x2="59.0426" y2="-0.5"
                                              transform="matrix(-0.0136856 0.999906 -0.999892 -0.0147332 164.049 593.697)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="banka" x1="224.156" y1="593.697" x2="224.156" y2="652.733"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <rect class="banka" x="0.633263" y="0.295166" width="18.86" height="54.6127"
                                              transform="matrix(0.935512 -0.353294 0.331013 0.943626 70.367 525.655)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <rect class="banka" x="0.633263" y="0.295166" width="18.86" height="54.6127"
                                              transform="matrix(0.935512 -0.353294 0.331013 0.943626 129.243 525.655)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <rect class="banka" x="0.633263" y="0.295166" width="18.86" height="54.6127"
                                              transform="matrix(0.935512 -0.353294 0.331013 0.943626 189.217 525.734)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="banka" y1="-0.5" x2="21.1113" y2="-0.5"
                                              transform="matrix(-0.331013 -0.943626 0.935512 -0.353294 79.7583 521.986)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="banka" y1="-0.5" x2="21.1113" y2="-0.5"
                                              transform="matrix(-0.331013 -0.943626 0.935512 -0.353294 139.074 521.986)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="banka" y1="-0.5" x2="21.1113" y2="-0.5"
                                              transform="matrix(-0.331013 -0.943626 0.935512 -0.353294 197.949 521.986)"
                                              :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="banka banka-dotted" x1="216.296" y1="548.609" x2="78.9924"
                                              y2="548.609" :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1" stroke-dasharray="8.45 8.45 8.45 8.45"/>
                                        <line class="contactor contactor-cross" x1="213.879" y1="673.521" x2="96.3474"
                                              y2="673.521" :stroke="model['contactor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['contactor']['value'] ? 2 : 1"/>
                                        <line class="input-switcher" x1="215.636" y1="280.095" x2="98.1047" y2="280.095"
                                              :stroke="model['inputSwitch']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['inputSwitch']['value'] ? 2 : 1"/>
                                        <line class="banka" x1="215.856" y1="678.535" x2="98.5439" y2="678.535"
                                              :stroke="model['contactor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['contactor']['value'] ? 2 : 1"/>
                                        <line class="input-switcher" x1="217.394" y1="285.109" x2="100.082" y2="285.109"
                                              :stroke="model['inputSwitch']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['inputSwitch']['value'] ? 2 : 1"/>
                                        <path class="banka" d="M106 594L99.1747 574.043" :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line class="contactor" y1="-0.5" x2="48.2682" y2="-0.5"
                                              transform="matrix(-0.349588 -0.936904 0.927932 -0.372751 106.191 697.957)"
                                              :stroke="model['contactor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['contactor']['value'] ? 2 : 1"/>
                                        <path class="input-switcher" d="M106.5 304.5L89.8415 259.494" :stroke="model['inputSwitch']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['inputSwitch']['value'] ? 2 : 1"/>
                                        <line class="contactor" y1="-0.5" x2="48.2682" y2="-0.5"
                                              transform="matrix(-0.349588 -0.936904 0.927932 -0.372751 165.286 697.957)"
                                              :stroke="model['contactor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['contactor']['value'] ? 2 : 1"/>
                                        <line class="input-switcher" y1="-0.5" x2="48.2682" y2="-0.5"
                                              transform="matrix(-0.349588 -0.936904 0.927932 -0.372751 163.53 304.531)"
                                              :stroke="model['inputSwitch']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['inputSwitch']['value'] ? 2 : 1"/>
                                        <line class="contactor" y1="-0.5" x2="48.2682" y2="-0.5"
                                              transform="matrix(-0.349588 -0.936904 0.927932 -0.372751 225.041 697.957)"
                                              :stroke="model['contactor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['contactor']['value'] ? 2 : 1"/>
                                        <line class="input-switcher" y1="-0.5" x2="48.2682" y2="-0.5"
                                              transform="matrix(-0.349588 -0.936904 0.927932 -0.372751 225.15 304.531)"
                                              :stroke="model['inputSwitch']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['inputSwitch']['value'] ? 2 : 1"/>
                                        <path class="banka" d="M164.5 594L158.05 574.043" :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <path class="banka" d="M224 594L217.585 574.043" :stroke="model['protection']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['protection']['value'] ? 2 : 1"/>
                                        <line x1="164.829" y1="800.502" x2="164.829" y2="697.502" stroke="black"/>
                                        <line class="busbar" x1="341.516" y1="460.396" x2="77.8935" y2="460.396"
                                              :stroke="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['busbar']['value'] ? 2 : 1"/>
                                        <line class="busbar" x1="341.516" y1="417.543" x2="77.8935" y2="417.543"
                                              :stroke="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['busbar']['value'] ? 2 : 1"/>
                                        <line class="busbar" x1="341.516" y1="375.374" x2="77.8935" y2="375.374"
                                              :stroke="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['busbar']['value'] ? 2 : 1"/>
                                        <ellipse class="busbar circle-busbar" cx="106" cy="376.15" rx="4" ry="4.15031"
                                                 :fill="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"/>
                                        <ellipse class="busbar circle-busbar" cx="162.855" cy="418" rx="3.85513" ry="4"
                                                 :fill="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"/>
                                        <ellipse class="busbar circle-busbar" cx="224.855" cy="461" rx="3.85513" ry="4"
                                                 :fill="model['busbar']['value'] ? 'rgb(12, 109, 253)' : 'black'"/>
                                        <line x1="98.8242" y1="17.4629" x2="98.8242" y2="259.308" stroke="black"/>
                                        <line x1="155.382" y1="259.308" x2="155.382" y2="59.6315" stroke="black"/>
                                        <line x1="217.235" y1="97.2422" x2="217.235" y2="259.308" stroke="black"/>
                                        <line x1="334.065" y1="100.363" x2="-0.114441" y2="100.363" stroke="black"/>
                                        <line x1="334.047" y1="144.926" x2="-0.0950623" y2="144.926" stroke="black"/>
                                        <line x1="334.047" y1="60.1318" x2="-0.0950623" y2="60.1318" stroke="black"/>
                                        <line x1="334.047" y1="17.9629" x2="-0.0950623" y2="17.9629" stroke="black"/>
                                        <ellipse cx="98.8551" cy="18" rx="3.85513" ry="4" fill="black"/>
                                        <ellipse cx="154.855" cy="61" rx="3.85513" ry="4" fill="black"/>
                                        <ellipse cx="216.855" cy="100" rx="3.85513" ry="4" fill="black"/>
                                        <path
                                            d="M5.13128 5.28467L2.2719 14H-0.0314867L3.87489 3.48673H5.34068L5.13128 5.28467ZM7.50688 14L4.64028 5.28467L4.40922 3.48673H5.88945L9.81749 14H7.50688ZM7.37691 10.0864V11.7833H1.82422V10.0864H7.37691Z"
                                            fill="black"/>
                                        <path
                                            d="M4.97243 50.6052H2.2719L2.25746 49.1178H4.52475C4.92429 49.1178 5.25163 49.0672 5.50676 48.9662C5.76189 48.8602 5.95203 48.7086 6.07719 48.5113C6.20716 48.3091 6.27214 48.0636 6.27214 47.7747C6.27214 47.4474 6.20957 47.1826 6.08441 46.9805C5.96406 46.7783 5.77392 46.6315 5.51398 46.54C5.25885 46.4485 4.9291 46.4028 4.52475 46.4028H3.02285V55.2192H0.856654V44.706H4.52475C5.1361 44.706 5.68246 44.7637 6.16384 44.8793C6.65003 44.9948 7.0616 45.1705 7.39857 45.4064C7.73553 45.6422 7.99307 45.9407 8.17118 46.3017C8.34929 46.6579 8.43834 47.0816 8.43834 47.5726C8.43834 48.0058 8.33966 48.4053 8.14229 48.7712C7.94974 49.137 7.64407 49.4355 7.22527 49.6666C6.81129 49.8976 6.26974 50.0252 5.60062 50.0492L4.97243 50.6052ZM4.87856 55.2192H1.67981L2.52463 53.5296H4.87856C5.25885 53.5296 5.56933 53.4694 5.81002 53.3491C6.05071 53.2239 6.22882 53.0554 6.34435 52.8436C6.45988 52.6318 6.51765 52.3887 6.51765 52.1144C6.51765 51.8063 6.4647 51.5391 6.35879 51.3129C6.2577 51.0866 6.09404 50.9133 5.86779 50.793C5.64154 50.6678 5.34309 50.6052 4.97243 50.6052H2.88566L2.9001 49.1178H5.49953L5.99776 49.7027C6.63799 49.693 7.15306 49.8062 7.54298 50.042C7.93771 50.2731 8.22413 50.574 8.40224 50.9446C8.58516 51.3153 8.67662 51.7124 8.67662 52.136C8.67662 52.8099 8.5298 53.378 8.23616 53.8401C7.94252 54.2974 7.51169 54.6416 6.94367 54.8726C6.38045 55.1037 5.69209 55.2192 4.87856 55.2192Z"
                                            fill="black"/>
                                        <path
                                            d="M6.95089 92.5315H9.10986C9.06654 93.2391 8.87158 93.8673 8.52499 94.4161C8.18321 94.9648 7.70424 95.3933 7.08808 95.7013C6.47673 96.0094 5.74022 96.1635 4.87856 96.1635C4.20463 96.1635 3.6005 96.0479 3.06617 95.8169C2.53185 95.581 2.07454 95.244 1.69425 94.806C1.31878 94.3679 1.03236 93.8384 0.834992 93.2174C0.637627 92.5965 0.538945 91.9009 0.538945 91.1307V90.4014C0.538945 89.6312 0.640034 88.9356 0.842213 88.3146C1.0492 87.6888 1.34284 87.1569 1.72313 86.7188C2.10823 86.2808 2.56795 85.9438 3.10228 85.7079C3.63661 85.4721 4.23351 85.3541 4.893 85.3541C5.76911 85.3541 6.50802 85.513 7.10974 85.8307C7.71628 86.1484 8.18562 86.5865 8.51777 87.1449C8.85473 87.7033 9.05691 88.3387 9.1243 89.0511H6.95811C6.93404 88.6275 6.8498 88.2689 6.70538 87.9752C6.56097 87.6768 6.34194 87.4529 6.0483 87.3037C5.75948 87.1497 5.37438 87.0727 4.893 87.0727C4.53197 87.0727 4.21667 87.14 3.94709 87.2748C3.67752 87.4096 3.45128 87.6142 3.26835 87.8886C3.08543 88.163 2.94824 88.5096 2.85678 88.9284C2.77013 89.3423 2.7268 89.8285 2.7268 90.3869V91.1307C2.7268 91.6746 2.76772 92.1536 2.84955 92.5676C2.93139 92.9767 3.05655 93.3233 3.22503 93.6073C3.39832 93.8865 3.61976 94.0983 3.88933 94.2428C4.16371 94.3824 4.49346 94.4522 4.87856 94.4522C5.33105 94.4522 5.70412 94.38 5.99776 94.2355C6.2914 94.0911 6.51524 93.8769 6.66928 93.5929C6.82814 93.3089 6.922 92.9551 6.95089 92.5315Z"
                                            fill="black"/>
                                        <path
                                            d="M4.63827 136.801H1.9594V135.111H4.63827C5.05225 135.111 5.38921 135.044 5.64916 134.909C5.9091 134.769 6.09924 134.577 6.21959 134.331C6.33993 134.086 6.4001 133.809 6.4001 133.501C6.4001 133.188 6.33993 132.897 6.21959 132.627C6.09924 132.358 5.9091 132.141 5.64916 131.977C5.38921 131.814 5.05225 131.732 4.63827 131.732H2.71035V140.548H0.544154V130.035H4.63827C5.46142 130.035 6.16664 130.184 6.75392 130.483C7.34601 130.776 7.79851 131.183 8.1114 131.703C8.4243 132.223 8.58074 132.817 8.58074 133.487C8.58074 134.165 8.4243 134.753 8.1114 135.248C7.79851 135.744 7.34601 136.127 6.75392 136.396C6.16664 136.666 5.46142 136.801 4.63827 136.801ZM17.13 138.859V140.548H11.534V138.859H17.13ZM12.2416 130.035V140.548H10.0754V130.035H12.2416ZM16.4007 134.317V135.963H11.534V134.317H16.4007ZM17.1228 130.035V131.732H11.534V130.035H17.1228ZM26.9501 130.035V140.548H24.7839L20.5598 133.501V140.548H18.3936V130.035H20.5598L24.7911 137.09V130.035H26.9501Z"
                                            fill="black"/>
                                        <ellipse class="transformer transformer-circle" cx="24.8551" cy="35"
                                                 rx="3.85513" ry="4" :fill="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"/>
                                        <ellipse class="transformer transformer-circle" cx="83.8551" cy="35"
                                                 rx="3.85513" ry="4" :fill="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"/>
                                        <path class="transformer transformer-circle"
                                              d="M24.5 18C24.5 13.5097 26.3316 9.08067 29.0985 5.92065C31.8638 2.76245 35.6025 1 39.4882 1C43.374 1 47.1126 2.76245 49.8779 5.92065C52.6448 9.08067 54 13.5097 54 18"
                                              :stroke="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['ta']['value'] == '1' ? 2 : 1"/>
                                        <path class="transformer transformer-circle"
                                              d="M54 18C54 13.5097 56.3316 9.08067 59.0985 5.92065C61.8638 2.76245 65.6025 1 69.4882 1C73.374 1 77.1126 2.76245 79.8779 5.92065C82.6448 9.08067 83.5 13.5097 83.5 18"
                                              :stroke="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['ta']['value'] == '1' ? 2 : 1"/>
                                        <line class="transformer" x1="24.5" y1="33" x2="24.5" y2="18" :stroke="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['ta']['value'] == '1' ? 2 : 1"/>
                                        <line class="transformer" x1="83.5" y1="33" x2="83.5" y2="18" :stroke="model['ta']['value'] == '1' ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['ta']['value'] == '1' ? 2 : 1"/>
                                        <path class="capasitor" d="M106 861L132.559 833.441" :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <path class="capasitor" d="M138.457 827.548L165 800" :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" y1="-0.5" x2="35" y2="-0.5"
                                              transform="matrix(0.693948 0.720025 -0.693948 0.720025 124.723 814.123)"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" y1="-0.5" x2="35" y2="-0.5"
                                              transform="matrix(0.693948 0.720025 -0.693948 0.720025 118.975 820.087)"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" y1="-0.5" x2="39.0649" y2="-0.5"
                                              transform="matrix(0.688081 0.725634 -0.699773 0.714365 164.669 800.902)"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <path class="capasitor" d="M198.379 834.193L224 862" :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" y1="-0.5" x2="35" y2="-0.5"
                                              transform="matrix(-0.693948 0.720025 -0.693948 -0.720025 211.321 819.941)"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" y1="-0.5" x2="35" y2="-0.5"
                                              transform="matrix(-0.693948 0.720025 -0.693948 -0.720025 205.573 813.978)"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" x1="170.934" y1="845" x2="170.934"
                                              y2="880" :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" opacity="0.8" x1="162.5" y1="845" x2="162.5" y2="880"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" x1="170.998" y1="862.177" x2="223.998" y2="862.177"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                        <line class="capasitor" x1="106" y1="861.862" x2="162.185" y2="861.862"
                                              :stroke="model['capacitor']['value'] ? 'rgb(12, 109, 253)' : 'black'"
                                              :stroke-width="model['capacitor']['value'] ? 2 : 1"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4233_48659">
                                            <rect width="263.337" height="880" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="krm-third-column krm-column">
                                <div class="field col-12 p-fluid">
                                    <p>TA, Трансформатор струму FRER</p>
                                    <div class="grid">
                                        <div class="field-radiobutton col-6">
                                            <RadioButton id="ta_yes" name="ta" value="1" v-model="model['ta']['value']" />
                                            <label for="ta_yes">Так</label>
                                        </div>
                                        <div class="field-radiobutton col-6">
                                            <RadioButton id="ta_no" name="ta" value="0" v-model="model['ta']['value']" />
                                            <label for="ta_no">Ні</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p>Коеф. трансформації</p>
                                    <div class="grid">
                                        <div class="col-9">
                                            <Dropdown
                                                :empty-message="emptyMessage"
                                                :loading="model['taCoefficient']['load']"
                                                v-model="model['taCoefficient']['value']"
                                                :options="taCoefficients"
                                                :show-clear="true"
                                                optionLabel="value"
                                                optionValue="id"
                                                placeholder="Вибрати значення" />
                                        </div>
                                        <div class="col-3 ta-coefficient">
                                           / 5
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p>ТА, Габарит FRER</p>
                                    <Dropdown
                                        :empty-message="emptyMessage"
                                        :loading="model['frer']['load']"
                                        v-model="model['frer']['value']"
                                        :show-clear="true"
                                        :options="frers"
                                        optionLabel="value"
                                        optionValue="id" placeholder="Вибрати значення" />
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p class="regulator-text">Регулятор</p>
                                </div>
                                <div class="field col-12 p-fluid">
                                    <div class="grid">
                                        <div class="regulator">
                                        </div>
                                        <div class="col-4">
                                            <div class="grid regulator-value">
                                                <div class="field-radiobutton col-12">
                                                    <RadioButton id="regulator_value_1" name="regulator_value" value="1" v-model="model['regulatorValue']['value']" />
                                                    <label for="regulator_value_1">1ф</label>
                                                </div>
                                                <div class="field-radiobutton col-12">
                                                    <RadioButton id="regulator_value_3" name="regulator_value" value="3" v-model="model['regulatorValue']['value']" />
                                                    <label for="regulator_value_3">3ф</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field-checkbox">
                                        <Checkbox id="binary" v-model="model['rs485']['value']" :binary="true" />
                                        <label for="binary">RS-485</label>
                                    </div>
                                    <div class="regulator-dropdown">
                                        <Dropdown
                                            :empty-message="emptyMessage"
                                            :loading="model['regulator']['load']"
                                            v-model="model['regulator']['value']"
                                            :options="regulators"
                                            :show-clear="true"
                                            optionLabel="value"
                                            optionValue="id" placeholder="Вибрати значення" />
                                    </div>
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p>Примусова вентиляція</p>
                                    <Dropdown
                                        :empty-message="emptyMessage"
                                        :loading="model['cooling']['load']"
                                        v-model="model['cooling']['value']"
                                        :show-clear="true"
                                        :options="coolings" optionLabel="value"
                                        optionValue="id" placeholder="Вибрати значення" />
                                    <div class="cooler">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
                                            <g><g>
                                                <path d="M56.15,0H3.85C1.727,0,0,1.727,0,3.85v52.3C0,58.273,1.727,60,3.85,60h52.3c2.123,0,3.85-1.727,3.85-3.85V3.85    C60,1.727,58.273,0,56.15,0z M58,56.15c0,1.02-0.83,1.85-1.85,1.85H3.85C2.83,58,2,57.17,2,56.15V3.85C2,2.83,2.83,2,3.85,2h52.3    C57.17,2,58,2.83,58,3.85V56.15z"/>
                                                <path d="M53,49c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S55.206,49,53,49z M53,55c-1.103,0-2-0.897-2-2s0.897-2,2-2    s2,0.897,2,2S54.103,55,53,55z"/>
                                                <path d="M53,11c2.206,0,4-1.794,4-4s-1.794-4-4-4s-4,1.794-4,4S50.794,11,53,11z M53,5c1.103,0,2,0.897,2,2s-0.897,2-2,2    s-2-0.897-2-2S51.897,5,53,5z"/>
                                                <path d="M7,49c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S9.206,49,7,49z M7,55c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2    S8.103,55,7,55z"/>
                                                <path d="M7,11c2.206,0,4-1.794,4-4S9.206,3,7,3S3,4.794,3,7S4.794,11,7,11z M7,5c1.103,0,2,0.897,2,2S8.103,9,7,9S5,8.103,5,7    S5.897,5,7,5z"/>
                                                <path d="M56.96,28.551c-0.081-1.525-0.295-3.014-0.62-4.462l0.011-0.013l-0.123-0.507c-0.014-0.058-0.034-0.114-0.048-0.172    c-0.123-0.489-0.258-0.974-0.408-1.452c-0.061-0.196-0.132-0.389-0.198-0.583c-0.103-0.305-0.209-0.608-0.323-0.908    c-0.09-0.237-0.182-0.471-0.279-0.705c-0.106-0.258-0.219-0.513-0.333-0.767c-0.17-0.379-0.348-0.753-0.536-1.123    c-0.13-0.257-0.258-0.514-0.396-0.766c-0.147-0.27-0.304-0.535-0.461-0.8c-0.102-0.172-0.205-0.343-0.31-0.512    c-0.172-0.276-0.345-0.55-0.526-0.82c-0.07-0.104-0.144-0.205-0.216-0.307c-0.374-0.541-0.769-1.067-1.183-1.58    c-0.086-0.106-0.169-0.213-0.256-0.318c-0.225-0.271-0.456-0.537-0.693-0.799c-0.091-0.101-0.185-0.2-0.278-0.3    c-0.198-0.213-0.387-0.433-0.592-0.641l-1.139-1.151l-0.022,0.064c-1.115-1.003-2.317-1.911-3.588-2.719l-0.002-0.029L43.996,6.91    c-0.28-0.17-0.569-0.321-0.855-0.48c-0.122-0.068-0.243-0.139-0.366-0.205c-0.279-0.15-0.561-0.294-0.845-0.434    c-0.21-0.104-0.422-0.203-0.635-0.302c-0.244-0.113-0.487-0.228-0.735-0.333c-0.448-0.191-0.903-0.371-1.363-0.538    C39.05,4.562,38.9,4.515,38.75,4.464c-0.388-0.133-0.779-0.258-1.174-0.374c-0.142-0.041-0.284-0.082-0.427-0.121    c-0.502-0.138-1.009-0.265-1.522-0.374c-0.018-0.004-0.036-0.009-0.055-0.013c-0.57-0.12-1.147-0.22-1.729-0.303    c-0.058-0.008-0.116-0.014-0.174-0.022c-0.507-0.069-1.018-0.123-1.533-0.164c-0.098-0.008-0.195-0.016-0.293-0.022    C31.234,3.029,30.62,3,30,3c-0.034,0-0.067,0.002-0.101,0.003l-1.373-0.007l0.022,0.045c-1.525,0.081-3.015,0.296-4.463,0.62    l-0.012-0.01l-0.506,0.123c-0.048,0.012-0.094,0.028-0.142,0.04c-0.507,0.127-1.009,0.267-1.505,0.423    c-0.163,0.051-0.322,0.11-0.484,0.164c-0.341,0.115-0.681,0.234-1.016,0.362c-0.216,0.082-0.43,0.167-0.644,0.254    c-0.288,0.119-0.573,0.244-0.856,0.372c-0.274,0.124-0.547,0.249-0.817,0.382c-0.347,0.171-0.691,0.347-1.029,0.532    C16.819,6.442,16.57,6.59,16.32,6.737c-0.19,0.112-0.379,0.226-0.566,0.343c-0.263,0.164-0.525,0.329-0.783,0.502    c-0.135,0.091-0.267,0.187-0.4,0.281c-0.499,0.348-0.986,0.713-1.461,1.096c-0.124,0.1-0.25,0.198-0.372,0.3    c-0.261,0.217-0.517,0.44-0.77,0.667c-0.117,0.105-0.232,0.214-0.347,0.321c-0.203,0.189-0.412,0.369-0.609,0.564L9.861,11.95    l0.063,0.021c-1.003,1.116-1.911,2.317-2.719,3.588l-0.029,0.002l-0.271,0.445c-0.168,0.277-0.318,0.564-0.476,0.847    c-0.07,0.125-0.142,0.248-0.21,0.374c-0.151,0.28-0.294,0.563-0.435,0.848c-0.102,0.206-0.199,0.414-0.296,0.622    c-0.115,0.25-0.232,0.498-0.34,0.75c-0.189,0.443-0.366,0.891-0.531,1.346c-0.06,0.165-0.112,0.331-0.169,0.497    c-0.125,0.366-0.243,0.735-0.353,1.109c-0.047,0.161-0.093,0.321-0.137,0.482c-0.127,0.464-0.243,0.932-0.346,1.406    c-0.012,0.056-0.027,0.111-0.039,0.167c-0.116,0.551-0.212,1.109-0.293,1.672c-0.014,0.095-0.024,0.191-0.037,0.287    c-0.062,0.462-0.111,0.927-0.149,1.396c-0.011,0.133-0.022,0.265-0.03,0.398c-0.033,0.506-0.055,1.016-0.06,1.53    c0,0.041-0.005,0.082-0.005,0.123v0.083C3.001,29.961,3,29.98,3,30c0,0.013,0.001,0.025,0.001,0.038l-0.008,1.438l0.047-0.023    c0.081,1.524,0.295,3.013,0.62,4.46l-0.012,0.013l0.123,0.507c0.015,0.063,0.036,0.123,0.052,0.186    c0.121,0.478,0.253,0.952,0.399,1.42c0.07,0.225,0.151,0.447,0.227,0.67c0.092,0.27,0.186,0.54,0.287,0.806    c0.098,0.26,0.2,0.518,0.306,0.775c0.09,0.217,0.185,0.431,0.28,0.646c0.253,0.569,0.524,1.128,0.815,1.678    c0.046,0.087,0.088,0.176,0.135,0.262c0.167,0.306,0.343,0.607,0.522,0.906c0.075,0.126,0.151,0.252,0.229,0.377    c0.192,0.311,0.387,0.619,0.592,0.923c0.005,0.007,0.01,0.014,0.015,0.021c0.455,0.673,0.944,1.324,1.46,1.956    c0.039,0.047,0.076,0.095,0.115,0.143c0.251,0.303,0.509,0.601,0.774,0.894c0.046,0.051,0.093,0.101,0.14,0.151    c0.228,0.249,0.449,0.503,0.687,0.743l1.139,1.151l0.022-0.066c1.115,1.003,2.316,1.91,3.587,2.719l0.002,0.032l0.445,0.271    c0.349,0.212,0.709,0.404,1.066,0.599c0.031,0.017,0.062,0.035,0.093,0.052c0.326,0.176,0.655,0.344,0.987,0.506    c0.138,0.068,0.278,0.133,0.418,0.199c0.307,0.143,0.613,0.287,0.925,0.419c0.412,0.175,0.828,0.339,1.25,0.493    c0.222,0.081,0.448,0.153,0.672,0.228c0.3,0.101,0.602,0.198,0.907,0.289c0.206,0.061,0.413,0.12,0.621,0.177    c0.388,0.105,0.78,0.201,1.175,0.289c0.126,0.028,0.25,0.061,0.377,0.087c0.522,0.109,1.051,0.2,1.583,0.278    c0.146,0.021,0.293,0.037,0.439,0.056c0.404,0.052,0.811,0.096,1.22,0.13c0.174,0.015,0.349,0.029,0.523,0.04    c0.439,0.028,0.881,0.045,1.326,0.052c0.09,0.001,0.18,0.01,0.27,0.01l1.619,0.009l-0.024-0.049    c1.524-0.081,3.013-0.295,4.461-0.62l0.014,0.012l0.507-0.123c0.068-0.017,0.134-0.04,0.202-0.057    c0.467-0.119,0.931-0.247,1.389-0.39c0.25-0.078,0.495-0.167,0.743-0.252c0.242-0.083,0.484-0.167,0.723-0.257    c0.278-0.104,0.553-0.213,0.828-0.327c0.19-0.079,0.376-0.162,0.564-0.245c1.008-0.445,1.986-0.95,2.932-1.515    c0.108-0.065,0.216-0.129,0.323-0.195c1.025-0.632,2.008-1.333,2.945-2.099c0.038-0.031,0.076-0.061,0.114-0.092    c0.307-0.254,0.608-0.515,0.904-0.783c0.048-0.044,0.095-0.088,0.143-0.132c0.25-0.229,0.505-0.452,0.747-0.691l1.151-1.139    l-0.066-0.022c1.003-1.115,1.911-2.316,2.719-3.587l0.031-0.002L53.094,44c0.199-0.327,0.377-0.665,0.561-1    c0.034-0.061,0.069-0.121,0.102-0.182c0.167-0.308,0.325-0.62,0.479-0.935c0.082-0.167,0.161-0.336,0.24-0.505    c0.131-0.281,0.262-0.561,0.383-0.846c0.182-0.428,0.353-0.861,0.513-1.3c0.069-0.189,0.129-0.38,0.193-0.57    c0.116-0.34,0.226-0.683,0.328-1.029c0.052-0.177,0.103-0.354,0.151-0.532c0.12-0.439,0.229-0.883,0.327-1.331    c0.017-0.078,0.037-0.154,0.054-0.232c0.114-0.544,0.209-1.094,0.29-1.65c0.015-0.105,0.026-0.211,0.04-0.317    c0.06-0.452,0.109-0.907,0.146-1.365c0.011-0.138,0.023-0.276,0.032-0.414c0.033-0.502,0.054-1.006,0.059-1.515    c0-0.043,0.005-0.087,0.005-0.13v-0.088C56.999,30.039,57,30.02,57,30c0-0.013-0.001-0.025-0.001-0.038l0.008-1.435L56.96,28.551z     M54.901,32.151c-0.026,0.303-0.058,0.605-0.095,0.906c-0.018,0.146-0.035,0.293-0.056,0.439    c-0.042,0.303-0.093,0.604-0.146,0.904c-0.026,0.144-0.049,0.289-0.077,0.432c-0.058,0.294-0.125,0.586-0.193,0.878    c-0.035,0.148-0.066,0.298-0.103,0.445c-0.066,0.262-0.143,0.521-0.218,0.781c-0.269,0.931-0.586,1.842-0.958,2.726    c-0.01,0.023-0.019,0.047-0.029,0.071c-0.153,0.36-0.314,0.715-0.483,1.066c-0.007,0.014-0.013,0.029-0.02,0.043    c-0.276,0.571-0.578,1.126-0.895,1.672c-8.45,0.43-14.068-1.744-17.54-6.835c0.059-0.042,0.112-0.092,0.169-0.136    c0.098-0.075,0.195-0.151,0.289-0.232c0.089-0.076,0.175-0.156,0.26-0.237c0.083-0.079,0.165-0.159,0.244-0.242    c0.082-0.086,0.161-0.173,0.239-0.263s0.153-0.183,0.226-0.277c0.067-0.087,0.134-0.174,0.197-0.263    c0.079-0.112,0.154-0.228,0.226-0.345c0.032-0.052,0.07-0.1,0.1-0.153c8.609,4.848,15.115,0.762,18.671-1.471    c0.07-0.043,0.138-0.087,0.206-0.13C54.912,32.004,54.908,32.078,54.901,32.151z M40.863,52.513    c-0.017,0.008-0.035,0.017-0.052,0.026c-0.326,0.157-0.658,0.306-0.992,0.449c-0.064,0.027-0.127,0.054-0.191,0.081    c-0.311,0.13-0.625,0.254-0.942,0.372c-0.09,0.033-0.18,0.065-0.27,0.097c-0.303,0.109-0.608,0.214-0.917,0.311    c-0.107,0.034-0.215,0.064-0.323,0.096c-0.239,0.072-0.48,0.141-0.722,0.205c-6.294-5.671-8.723-11.186-7.579-17.243    c0.046,0.007,0.092,0.009,0.138,0.015c0.155,0.022,0.311,0.04,0.469,0.052c0.092,0.007,0.183,0.011,0.275,0.014    C29.84,36.99,29.919,37,30,37c0.067,0,0.132-0.008,0.199-0.01c0.096-0.003,0.191-0.008,0.286-0.015    c0.15-0.01,0.299-0.025,0.446-0.045c0.084-0.011,0.168-0.024,0.252-0.039c0.161-0.028,0.319-0.061,0.477-0.099    c0.039-0.01,0.078-0.014,0.117-0.024c2.657,9.513,10.148,11.227,14.24,12.163c0.077,0.017,0.151,0.034,0.225,0.051    C44.614,50.376,42.811,51.57,40.863,52.513z M27.787,54.896c-0.256-0.022-0.511-0.05-0.766-0.08    c-0.189-0.023-0.379-0.045-0.567-0.072c-0.254-0.036-0.506-0.079-0.758-0.123c-0.19-0.033-0.38-0.064-0.568-0.102    c-0.236-0.047-0.469-0.101-0.703-0.154c-0.204-0.047-0.41-0.09-0.612-0.142c-0.164-0.042-0.326-0.091-0.489-0.136    c-2.065-0.573-4.021-1.404-5.835-2.458c-0.437-8.455,1.745-14.068,6.835-17.539c0.04,0.056,0.087,0.106,0.129,0.16    c0.078,0.102,0.157,0.202,0.24,0.3c0.075,0.088,0.154,0.172,0.233,0.256c0.079,0.083,0.159,0.165,0.243,0.245    c0.087,0.083,0.175,0.164,0.266,0.242c0.087,0.075,0.177,0.148,0.268,0.219c0.091,0.071,0.182,0.141,0.277,0.207    c0.105,0.074,0.213,0.143,0.323,0.212c0.057,0.036,0.111,0.077,0.17,0.111c-4.847,8.606-0.761,15.115,1.471,18.671    c0.043,0.069,0.086,0.137,0.128,0.204C27.976,54.911,27.881,54.905,27.787,54.896z M7.511,40.911    c-0.02-0.042-0.042-0.083-0.062-0.125c-0.147-0.306-0.286-0.616-0.421-0.929c-0.038-0.088-0.075-0.175-0.112-0.264    c-0.121-0.29-0.237-0.583-0.347-0.878c-0.043-0.115-0.083-0.23-0.124-0.346c-0.1-0.281-0.197-0.563-0.287-0.848    c-0.043-0.136-0.082-0.274-0.122-0.411c-0.065-0.217-0.128-0.435-0.186-0.655c5.674-6.296,11.182-8.726,17.245-7.578    c-0.005,0.029-0.005,0.058-0.009,0.086c-0.027,0.182-0.048,0.366-0.061,0.553c-0.005,0.068-0.008,0.135-0.01,0.203    C23.01,29.814,23,29.906,23,30c0,0.078,0.009,0.154,0.012,0.231c0.002,0.074,0.006,0.148,0.011,0.222    c0.011,0.171,0.028,0.34,0.051,0.507c0.009,0.067,0.02,0.134,0.031,0.201c0.029,0.173,0.064,0.343,0.106,0.512    c0.009,0.035,0.013,0.071,0.022,0.105c-9.512,2.657-11.226,10.148-12.162,14.24c-0.017,0.077-0.034,0.151-0.051,0.225    C9.636,44.63,8.452,42.841,7.511,40.911z M5.011,30.445c0.413-0.235,0.847-0.498,1.34-0.807c3.001-1.884,7.225-4.516,12.855-2.99    c-4.794,0.32-9.375,2.783-13.868,7.432C5.143,32.894,5.033,31.68,5.011,30.445z M5.098,27.863c0.027-0.313,0.06-0.626,0.098-0.937    c0.017-0.135,0.033-0.271,0.052-0.405c0.045-0.319,0.097-0.637,0.154-0.954c0.023-0.127,0.043-0.254,0.068-0.38    c0.063-0.322,0.135-0.642,0.211-0.961c0.028-0.12,0.053-0.241,0.083-0.36c0.082-0.326,0.175-0.648,0.271-0.97    c0.086-0.289,0.178-0.575,0.274-0.859c0.071-0.212,0.139-0.425,0.216-0.635c0.111-0.302,0.231-0.599,0.353-0.895    c0.037-0.09,0.071-0.18,0.109-0.269c0.135-0.316,0.277-0.628,0.424-0.937c0.029-0.061,0.057-0.123,0.087-0.184    c0.159-0.327,0.324-0.649,0.496-0.968c0.018-0.034,0.036-0.068,0.055-0.102c0.103-0.188,0.213-0.371,0.32-0.556    c8.445-0.445,14.07,1.744,17.542,6.835c-0.034,0.025-0.065,0.054-0.099,0.079c-0.134,0.101-0.266,0.204-0.392,0.314    c-0.064,0.055-0.126,0.113-0.188,0.171c-0.108,0.1-0.212,0.203-0.313,0.31c-0.063,0.067-0.125,0.135-0.186,0.205    c-0.096,0.11-0.187,0.222-0.276,0.337c-0.054,0.07-0.107,0.139-0.158,0.211c-0.092,0.129-0.178,0.262-0.261,0.397    c-0.026,0.042-0.056,0.081-0.081,0.124c-8.606-4.848-15.115-0.761-18.67,1.471c-0.07,0.044-0.138,0.087-0.206,0.13    C5.087,28.003,5.092,27.933,5.098,27.863z M14.086,10.734c0.023-0.019,0.046-0.037,0.069-0.056    c1.204-0.989,2.502-1.868,3.878-2.622c0.025-0.014,0.049-0.028,0.074-0.042c0.28-0.152,0.566-0.296,0.853-0.438    c0.106-0.053,0.212-0.106,0.319-0.157c0.256-0.122,0.515-0.238,0.775-0.351c0.144-0.063,0.289-0.125,0.435-0.185    c0.241-0.099,0.484-0.195,0.728-0.288c0.174-0.065,0.35-0.128,0.525-0.189c0.226-0.079,0.452-0.158,0.681-0.231    c0.212-0.068,0.427-0.129,0.641-0.191c0.159-0.046,0.317-0.093,0.477-0.136c6.296,5.672,8.725,11.188,7.581,17.245    c-0.023-0.004-0.045-0.004-0.068-0.007c-0.197-0.03-0.397-0.052-0.599-0.065c-0.046-0.003-0.092-0.005-0.139-0.007    C30.211,23.011,30.107,23,30,23c-0.089,0-0.176,0.01-0.264,0.013c-0.05,0.002-0.1,0.005-0.151,0.008    c-0.195,0.011-0.389,0.031-0.579,0.058c-0.044,0.006-0.087,0.013-0.131,0.02c-0.201,0.033-0.399,0.074-0.594,0.124    c-0.019,0.005-0.038,0.007-0.057,0.012c-2.657-9.512-10.148-11.226-14.24-12.162c-0.078-0.017-0.154-0.034-0.228-0.052    C13.866,10.926,13.973,10.827,14.086,10.734z M32.076,5.093c0.359,0.03,0.717,0.067,1.074,0.113    c0.094,0.012,0.188,0.023,0.281,0.036c0.366,0.05,0.73,0.11,1.092,0.176c0.084,0.016,0.169,0.029,0.253,0.045    c0.372,0.072,0.742,0.155,1.11,0.244c0.074,0.018,0.149,0.033,0.222,0.051c0.394,0.099,0.786,0.209,1.175,0.327    c0.045,0.014,0.092,0.025,0.137,0.039c0.401,0.124,0.798,0.261,1.192,0.405c0.279,0.103,0.554,0.215,0.828,0.327    c0.11,0.045,0.222,0.087,0.331,0.134c0.309,0.132,0.614,0.271,0.917,0.415c0.067,0.031,0.134,0.062,0.2,0.094    c0.325,0.158,0.647,0.323,0.964,0.495c0.033,0.018,0.066,0.036,0.099,0.054c0.189,0.103,0.373,0.214,0.559,0.322    c0.438,8.457-1.744,14.071-6.835,17.543c-0.027-0.037-0.059-0.071-0.086-0.107c-0.098-0.13-0.199-0.258-0.306-0.381    c-0.057-0.065-0.115-0.128-0.174-0.191c-0.1-0.107-0.203-0.212-0.31-0.313c-0.066-0.062-0.133-0.123-0.201-0.183    c-0.112-0.098-0.228-0.193-0.347-0.284c-0.065-0.05-0.13-0.1-0.198-0.148c-0.136-0.097-0.277-0.188-0.42-0.276    c-0.036-0.022-0.07-0.049-0.107-0.07c4.847-8.605,0.761-15.114-1.471-18.67c-0.044-0.071-0.088-0.14-0.131-0.208    C31.977,5.085,32.026,5.089,32.076,5.093z M49.282,14.105c0.002,0.002,0.004,0.004,0.005,0.006    c1.233,1.494,2.293,3.135,3.156,4.89c0.042,0.086,0.086,0.171,0.127,0.257c0.131,0.274,0.255,0.551,0.376,0.83    c0.053,0.122,0.105,0.245,0.156,0.368c0.109,0.262,0.213,0.526,0.313,0.793c0.054,0.145,0.106,0.292,0.158,0.438    c0.09,0.254,0.178,0.509,0.26,0.767c0.053,0.167,0.101,0.336,0.15,0.505c0.057,0.194,0.114,0.389,0.167,0.585    c-5.674,6.296-11.189,8.727-17.245,7.579c0.005-0.032,0.006-0.064,0.011-0.096c0.026-0.178,0.047-0.357,0.059-0.538    c0.005-0.071,0.008-0.141,0.011-0.212C36.99,30.185,37,30.094,37,30c0-0.078-0.009-0.154-0.012-0.231    c-0.002-0.072-0.006-0.143-0.011-0.215c-0.011-0.176-0.028-0.35-0.052-0.522c-0.008-0.06-0.017-0.12-0.027-0.179    c-0.03-0.184-0.068-0.365-0.113-0.543c-0.007-0.028-0.01-0.057-0.018-0.084c9.512-2.657,11.226-10.149,12.162-14.241    c0.017-0.077,0.035-0.152,0.051-0.227C49.081,13.874,49.185,13.987,49.282,14.105z M34.201,32.69    c-0.08,0.125-0.174,0.239-0.264,0.355c-0.104,0.134-0.206,0.268-0.322,0.39c-0.1,0.105-0.21,0.198-0.318,0.294    c-0.125,0.111-0.251,0.221-0.386,0.319c-0.126,0.09-0.26,0.169-0.395,0.248c-0.163,0.096-0.325,0.194-0.5,0.271    c-0.154,0.068-0.314,0.112-0.472,0.164c-0.145,0.048-0.288,0.102-0.438,0.136c-0.147,0.033-0.296,0.046-0.445,0.066    c-0.172,0.023-0.344,0.048-0.521,0.053c-0.152,0.004-0.305-0.008-0.457-0.018c-0.168-0.011-0.336-0.023-0.499-0.05    s-0.324-0.068-0.485-0.111c-0.183-0.05-0.365-0.099-0.539-0.168c-0.146-0.058-0.281-0.134-0.419-0.204    c-0.146-0.075-0.294-0.146-0.431-0.234c-0.122-0.078-0.233-0.17-0.347-0.258c-0.135-0.105-0.271-0.208-0.395-0.326    c-0.106-0.1-0.2-0.212-0.296-0.321c-0.109-0.123-0.218-0.247-0.314-0.381c-0.093-0.13-0.174-0.269-0.256-0.408    c-0.094-0.161-0.191-0.319-0.267-0.491c-0.07-0.158-0.115-0.323-0.168-0.486c-0.045-0.138-0.097-0.274-0.13-0.417    c-0.036-0.16-0.051-0.322-0.071-0.484c-0.02-0.157-0.043-0.314-0.048-0.476c-0.005-0.167,0.008-0.335,0.02-0.503    c0.011-0.151,0.022-0.302,0.045-0.45c0.029-0.179,0.073-0.355,0.122-0.531c0.046-0.167,0.091-0.334,0.154-0.494    c0.067-0.171,0.154-0.33,0.239-0.491c0.064-0.12,0.122-0.244,0.195-0.358c0.092-0.144,0.199-0.276,0.304-0.409    c0.09-0.114,0.177-0.229,0.276-0.335c0.117-0.124,0.246-0.235,0.375-0.346c0.106-0.091,0.21-0.184,0.323-0.266    c0.15-0.109,0.31-0.203,0.472-0.296c0.141-0.081,0.279-0.166,0.429-0.233c0.189-0.084,0.386-0.141,0.582-0.201    c0.108-0.033,0.213-0.075,0.324-0.101c0.178-0.041,0.359-0.058,0.539-0.079c0.141-0.017,0.28-0.038,0.424-0.043    c0.178-0.006,0.356,0.008,0.534,0.021c0.142,0.011,0.283,0.02,0.421,0.043c0.184,0.03,0.367,0.075,0.548,0.126    c0.161,0.045,0.324,0.088,0.478,0.149c0.179,0.07,0.346,0.161,0.513,0.25c0.114,0.061,0.231,0.115,0.339,0.184    c0.147,0.093,0.281,0.203,0.417,0.31c0.112,0.089,0.226,0.174,0.33,0.272c0.123,0.116,0.233,0.244,0.344,0.372    c0.093,0.107,0.187,0.213,0.271,0.328c0.106,0.146,0.197,0.302,0.287,0.459c0.084,0.147,0.173,0.29,0.242,0.446    c0.077,0.173,0.128,0.353,0.184,0.532c0.039,0.125,0.087,0.246,0.117,0.375c0.038,0.165,0.053,0.333,0.073,0.5    c0.019,0.154,0.042,0.307,0.047,0.465c0.005,0.167-0.008,0.333-0.02,0.5c-0.011,0.154-0.022,0.307-0.046,0.457    c-0.029,0.175-0.072,0.348-0.12,0.52c-0.048,0.173-0.094,0.346-0.159,0.511c-0.061,0.154-0.14,0.296-0.215,0.442    C34.353,32.417,34.285,32.559,34.201,32.69z M46.979,13.538c-0.79,3.454-1.916,8.304-6.977,11.204    c3.162-3.613,4.66-8.591,4.552-15.05c0.989,0.711,1.925,1.492,2.799,2.337C47.229,12.485,47.109,12.975,46.979,13.538z     M30.364,6.354c1.884,3.001,4.517,7.227,2.99,12.857c-0.319-4.795-2.783-9.379-7.434-13.872c1.186-0.196,2.4-0.305,3.636-0.327    C29.791,5.425,30.055,5.86,30.364,6.354z M13.537,13.022c3.455,0.79,8.307,1.917,11.207,6.982    c-3.616-3.164-8.6-4.663-15.053-4.557c0.711-0.99,1.492-1.925,2.337-2.8C12.484,12.773,12.974,12.893,13.537,13.022z     M13.021,46.465c0.79-3.453,1.916-8.302,6.976-11.203c-3.161,3.612-4.659,8.589-4.552,15.046    c-0.989-0.711-1.924-1.491-2.798-2.336C12.771,47.516,12.892,47.026,13.021,46.465z M29.636,53.65    c-1.884-3.001-4.517-7.227-2.99-12.857c0.319,4.794,2.782,9.376,7.432,13.868c-1.186,0.195-2.4,0.305-3.636,0.327    C30.207,54.576,29.944,54.143,29.636,53.65z M46.463,46.981c-3.459-0.791-8.32-1.919-11.219-7.003    c3.493,3.068,8.256,4.588,14.412,4.587c0.213,0,0.442-0.018,0.659-0.022c-0.714,0.994-1.497,1.933-2.346,2.811    C47.514,47.23,47.025,47.11,46.463,46.981z M53.648,30.366c-3,1.884-7.226,4.518-12.858,2.99    c4.795-0.318,9.378-2.786,13.871-7.436c0.196,1.187,0.306,2.402,0.327,3.639C54.576,29.794,54.142,30.057,53.648,30.366z"/>
                                            </g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                                        </svg>
                                    </div>
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p>Металоконструкція</p>
                                    <Dropdown
                                        :empty-message="emptyMessage"
                                        :loading="model['metalStructure']['load']"
                                        v-model="model['metalStructure']['value']"
                                        :options="metalStructures"
                                        :show-clear="true"
                                        optionLabel="value"
                                        optionValue="id"
                                        placeholder="Вибрати значення" />
                                </div>
                                <div class="field col-12 p-fluid">
                                    <p>Відображення параметрів</p>
                                    <div class="grid">
                                        <div class="field-radiobutton col-12">
                                            <RadioButton id="params_control_no" name="params_control" :value="false" v-model="model['paramsControl']['value']" />
                                            <label for="params_control_no">Ні</label>
                                        </div>
                                        <div class="field-radiobutton col-12">
                                            <RadioButton id="params_control_1f" name="params_control" value="1" v-model="model['paramsControl']['value']" />
                                            <label for="params_control_1f">
                                                1ф. <span class="circle-txt-around">A</span>
                                            </label>
                                        </div>
                                        <div class="field-radiobutton col-12">
                                            <RadioButton id="params_control_3f" name="params_control" value="3" v-model="model['paramsControl']['value']" />
                                            <label for="params_control_3f">
                                                3ф. <span class="circle-txt-around">A</span>
                                            </label>
                                        </div>
                                        <div class="field-radiobutton col-12">
                                            <RadioButton id="params_control_3fplus" name="params_control" value="3+" v-model="model['paramsControl']['value']" />
                                            <label for="params_control_3fplus">
                                                3ф. <span class="rec-txt-around"><span class="circle-txt-around">А</span> + <span class="circle-txt-around">V</span></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="krm-fourth-column krm-column">
                                <p class="power-manage">
                                    Розподіл потужності по ступеням
                                </p>
                                <TabView v-model:activeIndex="activeMode" class="power-manage-table">
                                    <TabPanel header="Автоматичний режим">
                                        <DataTable :value="variants" showGridlines removableSort responsiveLayout="scroll" scrollHeight="475px">
                                            <Column field="variant" header="Варіанти ступенів">
                                                <template #body="slotProps">
                                                    <span class="td-step-variant">
                                                        {{ displayStepVariant(slotProps.data.variant, "7") }}
                                                    </span>
                                                </template>
                                            </Column>
                                            <Column field="price" sortable header="Ціна, грн. з ПДВ">
                                                <template #body="slotProps">
                                                    <span class="td-step-price">
                                                    {{ valueWithNds(slotProps.data.price) }}
                                                    </span>
                                                </template>
                                            </Column>
                                            <Column field="actions" header="">
                                                <template #body="slotProps">
                                                    <div class="table-buttons">
                                                        <Button
                                                            v-tooltip.top="{ value: 'Переглянути специфікацію', disabled: isDisableTooltip }"
                                                            icon="pi pi-book"
                                                            class="p-button-krm p-button-text"
                                                            @click="openModalPrice(slotProps.data, slotProps.index)"
                                                        />
                                                        <Button
                                                            v-tooltip.top="{ value: 'Завантажити в Excel', disabled: isDisableTooltip }"
                                                            icon="pi pi-file-excel"
                                                            class="p-button-krm p-button-text"
                                                            @click="downloadPrice(slotProps.index)"

                                                        />
                                                    </div>
                                                </template>
                                            </Column>
                                            <template #empty>
                                                Варіанти установки для вибраних параметрів відсутні. Спробуйте змінити початкові дані або параметри фільтрів
                                            </template>
                                        </DataTable>
                                    </TabPanel>
                                    <TabPanel header="Ручний режим">
                                        <div class="p-datatable p-datatable-gridlines manual-mode">
                                            <table role="table" class="p-datatable-table">
                                                <thead class="p-datatable-thead" role="rowgroup">
                                                <tr role="row">
                                                    <th class="" role="cell">
                                                        <div class="p-column-header-content">
                                                            <span class="p-column-title">Номер ступені</span>
                                                        </div>
                                                    </th>
                                                    <th class="" role="cell">
                                                        <div class="p-column-header-content">
                                                            <span class="p-column-title">Потужність ступені</span>
                                                        </div>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody class="p-datatable-tbody" role="rowgroup" v-if="model.stepsNumber.value">
                                                <tr class="" role="row" v-for="step in model.stepsNumber.value" :key="step">
                                                    <td class="" role="cell">{{ step }}</td>
                                                    <td class="" role="cell">
                                                        <Dropdown
                                                            :empty-message="emptyMessage"
                                                            v-model="manualVariant[step]"
                                                            :options="minSteps"
                                                            optionLabel="value"
                                                            optionValue="id"
                                                            placeholder="Вибрати значення"
                                                            :loading="model['minStep']['load']"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr class="" role="row">
                                                    <td class="" role="cell">Потужність КУ, кВАр</td>
                                                    <td class="" role="cell">
                                                        <InputNumber
                                                            v-model="model['power']['value']"
                                                            :disabled="model['power']['readonly']"
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tbody class="p-datatable-tbody" role="rowgroup" v-else>
                                                <tr class="p-datatable-emptymessage" role="row">
                                                    <td colspan="2">
                                                        Вкажіть кількість ступенів
                                                </td></tr>
                                                </tbody>
                                                <tfoot class="p-datatable-tfoot" role="rowgroup" v-if="this.variants[0]">
                                                <tr class="p-datatable-emptymessage" role="row">
                                                    <td>
                                                        Ціна, грн. з ПДВ:
                                                    </td>
                                                    <td>
                                                        <span style="float: left; line-height: 18px">
                                                            {{ valueWithNds(this.variants[0].price) }} грн.
                                                        </span>
                                                        <span style="float: right">
                                                            <Button
                                                                v-tooltip.bottom="{ value: 'Переглянути специфікацію', disabled: isDisableTooltip }"
                                                                icon="pi pi-book"
                                                                class="p-button-krm p-button-text"
                                                                @click="openModalPrice(this.variants[0], 0)"
                                                            />
                                                            <Button
                                                                v-tooltip.bottom="{ value: 'Завантажити в Excel', disabled: isDisableTooltip }"
                                                                icon="pi pi-file-excel"
                                                                class="p-button-krm p-button-text"
                                                                @click="downloadPrice(0)"

                                                            />
                                                        </span>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </TabPanel>
                                </TabView>
                            </div>
                        </div>
                    </preload-form>
                </div>

            </div>
            <Dialog
                class="krm-spec"
                :dismissable-mask="true"
                :draggable="false"
                header="Специфікація"
                v-model:visible="displayModalPrice"
                :style="{width: '90%', borderRadius: '15px', overflow: 'hidden'}" :modal="true">
                <p style="word-break: break-all" class="bolder-pg">
                    Номінал конденсаторних банок: {{ displayStepVariant(selectedVariant) }}
                </p>
                <div v-for="(productList, productType) in splitProductsByType(selectedProducts)" v-if="splitOrderList">
                    <p class="bolder-pg m-t-1" v-if="productList.length > 0">{{ typeMap[productType] }}</p>
                    <KrmOrderList :product-list="productList" v-if="productList.length > 0"></KrmOrderList>
                </div>
                <KrmOrderList :product-list="selectedProducts" v-else></KrmOrderList>

                <template #footer>
                    <div class="krm-spec-buttons">
                        <Button class="button-krm-link p-button-text" label="Повернутись до конфігуратора" @click="closeModalPrice()" />
                        <Button class="button-krm-primary" label="Підсумувати" v-on:click="splitOrderList = false" v-if="splitOrderList" />
                        <Button class="button-krm-primary" label="Розділити" v-on:click="splitOrderList = true" v-else />
                        <Button class="button-krm-secondary" label="Завантажити в Excel" @click="downloadPrice(selectedVariantIndex)" />


                    </div>

                    <div class="commercial_offer">
                        <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                            <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                                <g clip-path="url(#clip0_7979_151607)">
                                    <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7979_151607">
                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                            <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                            
                            <div class="flex-group customer_info">
                                <div class="flex_form">
                                    <div class="flex-row">
                                        <div class="form_grid">
                                            <div class="form_group">
                                                <label class="form_label">Організація</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                            </div>
                                            <div class="form_group">
                                                <label class="form_label">Контактна особа</label>
                                                <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                            </div>
                                        </div>
                                        <div class="form_grid">
                                            <div class="form_group">
                                                <label class="form_label">Номер телефону *</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                                <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                            </div>
                                            <div class="form_group">
                                                <label class="form_label">Електронна пошта *</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                                <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex_form">
                                    <div class="form_group mr-9">
                                        <label class="form_label">Комментар до замовлення</label>
                                        <div class="textarea_container">
                                            <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                            <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="commercial_offer_order" v-if="commercial_offer_sended">
                                <div class="block_row">
                                    <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                                    <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                                    </svg>
                                </div>
                                <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                                <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                            </div>

                            <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                                <template v-if="is_disable_commercial_offer_btn">
                                    Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                                </template>
                                <template v-else>Замовити</template>
                            </a>
                            <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                                Замовити
                            </a>
                        </div>
                    </div>
                </template>
            </Dialog>

            <div class="overlay" v-if="displayKrpModal" v-on:click="() => {displayKrpModal = false;}"></div>
            <div class="modal description_modal" v-if="displayKrpModal">
                <div class="modal_container">
                    <div class="modal_header">
                        <p class="modal_header_title">Опис роботи сервісу</p>
                        <svg id="close_modal" v-on:click="displayKrpModal = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="modal_content" v-html="krmDescription"></div>
                </div>
            </div>
        </div>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import KrmService from "../Services/KrmService";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Tooltip from 'primevue/tooltip';
import KrmOrderList from "@/Pages/KrmOrderList";
import ProgressSpinner from 'primevue/progressspinner';


export default {
    directives: {
        Tooltip,
    },
    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        KrmOrderList,
        ProgressSpinner
    },
    layout: CommonLayout,
    computed: {
        isDisableTooltip() {
            return window.innerWidth < 1400;
        }
    },
    data() {
        return {
            displayKrpModal: false,
            model: {
                rs485: {
                    value: false,
                },
                ta: {
                    value: '0',
                },
                filter: {
                    default: 'no',
                    value: 'no',
                },
                inputSwitch: {
                    default: null,
                    value: null,
                    load: false,
                },
                power: {
                    readonly: false,
                    value: 100,
                    load: false,
                },
                stepsNumber: {
                    default: null,
                    value: null,
                    load: false,
                },
                minStep: {
                    readonly: false,
                    default: null,
                    value: null,
                    load: false,
                },
                busbar: {
                    default: false,
                    value: false,
                    load: false,
                },
                protection: {
                    default: null,
                    value: null,
                    load: false,
                },
                contactor: {
                    default: null,
                    value: null,
                    load: false,
                },
                capacitor: {
                    default: null,
                    value: null,
                    load: false,
                },
                voltageCapacitor: {
                    default: null,
                    value: null,
                    load: false,
                },
                taCoefficient: {
                    default: null,
                    value: null,
                    load: false,
                },
                frer: {
                    default: null,
                    value: null,
                    load: false,
                },
                regulator: {
                    default: null,
                    value: null,
                    load: false,
                },
                cooling: {
                    default: null,
                    value: null,
                    load: false,
                },
                metalStructure: {
                    default: null,
                    value: null,
                    load: false,
                },
                paramsControl: {
                    default: false,
                    value: false,
                    load: false,
                },
                regulatorValue: {
                    default: '1',
                    value: '1',
                    load: false,
                },
                rs345: {
                    default: null,
                    value: null,
                    load: false,
                }
            },
            variants: [],
            stepsNumber: [],
            minSteps: [],
            inputSwitches: [],
            krmDescription: '',
            protections: [],
            contactors: [],
            capacitors: [],
            voltageCapacitors: [],
            taCoefficients: [],
            frers: [],
            regulators: [],
            coolings: [],
            metalStructures: [],
            emptyMessage: "Немає доступних опцій",
            displayModalPrice: false,
            selectedProducts: [],
            selectedVariantIndex: [],
            manualVariant: {},
            activeMode: 0,
            selectedVariant: [],
            splitOrderList: true,
            typeMap: {
                'metal_structure': 'Металоконструкція',
                'other': 'Комплектація',
                'bus_bar': 'Ошинівка та додат. матеріали',
            },

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
        }
    },
    watch: {
        'model.power.value': function (newValue) {
            this.loadData()
        },
        'model.stepsNumber.value': function (newValue) {
            Object.keys(this.manualVariant).forEach(key => {
                if (key >= newValue) {
                    delete this.manualVariant[key];
                }
            });
            // this.manualVariant.splice(0, newValue);
            this.loadData()
        },
        'model.minStep.value': function (newValue) {
            this.loadData()
        },
        'model.protection.value': function (newValue) {
            this.loadData()
        },
        'model.metalStructure.value': function (newValue) {
            this.loadData()
        },
        'model.inputSwitch.value': function (newValue) {
            this.loadData()
        },
        'model.busbar.value': function (newValue) {
            this.loadData()
        },
        'model.filter.value': function (newValue) {
            this.loadData()
        },
        'model.contactor.value': function (newValue) {
            this.loadData()
        },
        'model.capacitor.value': function (newValue) {
            this.loadData()
        },
        'model.voltageCapacitor.value': function (newValue) {
            this.loadData()
        },
        'model.ta.value': function (newValue) {
            this.loadData()
        },
        'model.taCoefficient.value': function (newValue) {
            this.loadData()
        },
        'model.regulator.value': function (newValue) {
            this.loadData()
        },
        'model.frer.value': function (newValue) {
            this.loadData()
        },
        'model.regulatorValue.value': function (newValue) {
            this.loadData()
        },
        'model.rs485.value': function (newValue) {
            this.loadData()
        },
        'model.cooling.value': function (newValue) {
            this.loadData()
        },
        'model.paramsControl.value': function (newValue) {
            this.loadData()
        },
        'activeMode': function (newValue) {
            if (newValue) {
                this.calculateManualPower()
            }
            this.model.power.readonly = (newValue === 1)
            this.model.minStep.readonly = (newValue === 1)
            this.loadData()
        },
        'manualVariant': {
            handler: function() {
                this.calculateManualPower()
            },
            deep: true,
        },
    },
    created() {
        this.krmService = new KrmService();
        this.loadData();
    },
    methods: {
        displayStepVariant(variant, nIndex) {
            if (!variant) {
                return '';
            }

            let variantDisplay = '';
            Object.keys(variant).forEach(key => {
                if (nIndex && key === nIndex) {
                    variantDisplay += "\n";
                }
                variantDisplay += variant[key] + '+';
            });

            return variantDisplay.substring(0, variantDisplay.length-1);
        },
        openKrpModal() {
            this.displayKrpModal = true;
        },
        closeKrpModal() {
            this.displayKrpModal = false;
        },
        isManualVariantReady() {
            return Object.keys(this.manualVariant).length === this.model.stepsNumber.value
        },
        calculateManualPower() {
            let sum = 0
            Object.keys(this.manualVariant).forEach(key => {
                sum += this.manualVariant[key]
            });
            this.model.power.value = sum
        },
        openModalPrice(data, selectedVariantIndex) {
            this.selectedVariant = data.variant;
            this.selectedProducts = data.products;
            this.selectedVariantIndex = selectedVariantIndex;
            this.displayModalPrice = true;
        },
        downloadPrice(selectedVariantIndex) {
            this.selectedVariantIndex = selectedVariantIndex;
            this.downloadData();
        },
        closeModalPrice() {
            this.displayModalPrice = false;
        },
        splitedVariant(variant) {
            return variant.split('+');
        },
        calculateCommonSumNoNds() {
            let sum = 0;
            Object.keys(this.selectedProducts).forEach(key => {
                sum += this.selectedProducts[key]['priceNoNds'] * this.selectedProducts[key]['count']
            });

            return sum;
        },
        calculateCommonSumWithNds() {
            let sum = 0;
            Object.keys(this.selectedProducts).forEach(key => {
                sum += this.selectedProducts[key]['price'] * this.selectedProducts[key]['count']
            });

            return sum;
        },
        valueWithNds(value) {
            return (value * 1.0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        calculateNds() {
            return (this.calculateCommonSumWithNds() - this.calculateCommonSumNoNds()).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        calculateSumWithNds() {
            return this.calculateCommonSumWithNds().toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        splitProductsByType(selectedProducts) {
            let typedProducts = {};
            Object.keys(this.typeMap).forEach(key => {
                typedProducts[key] = [];
            })
            Object.keys(selectedProducts).forEach(key => {
                typedProducts[selectedProducts[key]['type']].push(selectedProducts[key])
            });

            return typedProducts
        },
        clearIfNotExists(stack, model) {
            let isset = false;
            stack.forEach(function (value) {
                if (value['id'] === model.value) {
                    isset = true;
                }
            }.bind(this));

            if (!isset) {
                model.value = model.default;
            }
        },
        loadData() {
            this.baseLoad('api.krm.list')
        },
        downloadData() {
            axios.post(this.route('api.krm.doc'), this.getRequestData(),
                {
                    responseType: 'blob'
                }
            )
            .then(function (result) {
                let blob = new Blob([result.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'kp-'+Date.now()+'.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        baseLoad(route) {
            this.model.inputSwitch.load = true;
            this.model.protection.load = true;
            this.model.contactor.load = true;
            this.model.metalStructure.load = true;
            this.model.paramsControl.load = true;
            this.model.capacitor.load = true;
            this.model.voltageCapacitor.load = true;
            this.model.taCoefficient.load = true;
            this.model.frer.load = true;
            this.model.regulator.load = true;
            this.model.cooling.load = true;
            this.krmService.getData(this.route(route), this.getRequestData()).then(data => {
                this.krmDescription = data['krmDescription']
                this.inputSwitches = data['inputSwitches']
                this.clearIfNotExists(this.inputSwitches, this.model.inputSwitch)
                this.stepsNumber = data['stepsNumber']
                this.clearIfNotExists(this.stepsNumber, this.model.stepsNumber)
                this.minSteps = data['minSteps']
                this.clearIfNotExists(this.minSteps, this.model.minStep)
                this.protections = data['protections']
                this.clearIfNotExists(this.protections, this.model.protection)
                this.contactors = data['contactors']
                this.clearIfNotExists(this.contactors, this.model.contactor)
                this.metalStructures = data['metalStructures']
                this.clearIfNotExists(this.metalStructures, this.model.metalStructure)
                this.capacitors = data['capacitors']
                this.clearIfNotExists(this.capacitors, this.model.capacitor)
                this.voltageCapacitors = data['capacitorVoltages']
                this.clearIfNotExists(this.voltageCapacitors, this.model.voltageCapacitor)
                this.taCoefficients = data['taCoefficients']
                this.clearIfNotExists(this.taCoefficients, this.model.taCoefficient)
                this.frers = data['frers']
                this.clearIfNotExists(this.frers, this.model.frer)
                this.regulators = data['regulators']
                this.variants = data['variants']
                this.clearIfNotExists(this.coolings, this.model.cooling)
                this.coolings = data['coolings']
                this.selectedProducts = data['products']
                this.clearIfNotExists(this.regulators, this.model.regulator)


                this.model.inputSwitch.load = false;
                this.model.protection.load = false;
                this.model.contactor.load = false;
                this.model.metalStructure.load = false;
                this.model.paramsControl.load = false;
                this.model.capacitor.load = false;
                this.model.voltageCapacitor.load = false;
                this.model.taCoefficient.load = false;
                this.model.frer.load = false;
                this.model.regulator.load = false;
                this.model.cooling.load = false;
            });
        },
        getRequestData() {
            return {
                power: this.model.power.value,
                stepNumber: this.model.stepsNumber.value,
                minStep: this.model.minStep.value,
                inputSwitch: this.model.inputSwitch.value,
                protection: this.model.protection.value,
                metalStructure: this.model.metalStructure.value,
                busbar: this.model.busbar.value,
                paramsControl: this.model.paramsControl.value,
                capacitor: this.model.capacitor.value,
                voltageCapacitor: this.model.voltageCapacitor.value,
                filterCapacitor: this.model.filter.value,
                ta: this.model.ta.value,
                taCoefficient: this.model.taCoefficient.value,
                frer: this.model.frer.value,
                regulator: this.model.regulator.value,
                regulatorValue: this.model.regulatorValue.value,
                rs485: this.model.rs485.value,
                cooling: this.model.cooling.value,
                contactor: this.model.contactor.value,
                selectedVariantIndex: this.selectedVariantIndex,
                manualVariant: this.activeMode && this.isManualVariantReady() ? Object.values(this.manualVariant) : null,
                auto: !this.activeMode,
                splitOrderList: this.splitOrderList,
            };
        },

        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'Krm',

                    power: this.model.power.value,
                    stepNumber: this.model.stepsNumber.value,
                    minStep: this.model.minStep.value,
                    inputSwitch: this.model.inputSwitch.value,
                    protection: this.model.protection.value,
                    metalStructure: this.model.metalStructure.value,
                    busbar: this.model.busbar.value,
                    paramsControl: this.model.paramsControl.value,
                    capacitor: this.model.capacitor.value,
                    voltageCapacitor: this.model.voltageCapacitor.value,
                    filterCapacitor: this.model.filter.value,
                    ta: this.model.ta.value,
                    taCoefficient: this.model.taCoefficient.value,
                    frer: this.model.frer.value,
                    regulator: this.model.regulator.value,
                    regulatorValue: this.model.regulatorValue.value,
                    rs485: this.model.rs485.value,
                    cooling: this.model.cooling.value,
                    contactor: this.model.contactor.value,
                    selectedVariantIndex: this.selectedVariantIndex,
                    manualVariant: this.activeMode && this.isManualVariantReady() ? Object.values(this.manualVariant) : null,
                    auto: !this.activeMode,
                    splitOrderList: this.splitOrderList,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: 0,
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>
<style scoped>
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}
.modal_header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}
#close_modal {
    cursor: pointer;
}
.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}
@media (max-width: 420px) {
    .modal {
        width: 385px;
    }
    .description_btn_container {
        width: 100%;
    }
}
@media (max-width: 390px) {
    .description_modal, .docs_modal {
        width: 330px;
    }
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    text-align: left;
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
}
</style>
